
export const exampleAdsenseAds = [
  {
    name: "Header Banner Ad - Leaderboard",
    type: "banner",
    position: "header",
    content: `<!-- Replace with your AdSense code -->
    <div style="width: 100%; height: 90px; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); display: flex; align-items: center; justify-content: center; color: white; font-family: Arial, sans-serif; border-radius: 8px;">
      <div style="text-align: center;">
        <div style="font-size: 18px; font-weight: bold;">Advertisement</div>
        <div style="font-size: 12px; opacity: 0.8;">728x90 Leaderboard Banner - Replace with AdSense</div>
      </div>
    </div>`,
    image_url: "",
    link_url: "",
    active: true,
    start_date: null,
    end_date: null,
  },
  {
    name: "Sidebar Square Ad - Medium Rectangle",
    type: "sidebar",
    position: "sidebar",
    content: `<!-- Replace with your AdSense code -->
    <div style="width: 300px; height: 250px; background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); display: flex; align-items: center; justify-content: center; color: white; font-family: Arial, sans-serif; border-radius: 8px;">
      <div style="text-align: center;">
        <div style="font-size: 16px; font-weight: bold;">Advertisement</div>
        <div style="font-size: 12px; opacity: 0.8;">300x250 Rectangle - Replace with AdSense</div>
      </div>
    </div>`,
    image_url: "",
    link_url: "",
    active: true,
    start_date: null,
    end_date: null,
  },
  {
    name: "Before Game Ad - Large Banner",
    type: "banner",
    position: "before-game",
    content: `<!-- Replace with your AdSense code -->
    <div style="width: 100%; height: 120px; background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); display: flex; align-items: center; justify-content: center; color: white; font-family: Arial, sans-serif; border-radius: 8px;">
      <div style="text-align: center;">
        <div style="font-size: 18px; font-weight: bold;">Advertisement</div>
        <div style="font-size: 12px; opacity: 0.8;">Before Game Banner - Replace with AdSense</div>
      </div>
    </div>`,
    image_url: "",
    link_url: "",
    active: true,
    start_date: null,
    end_date: null,
  },
  {
    name: "Footer Banner Ad - Responsive",
    type: "banner",
    position: "footer",
    content: `<!-- Replace with your AdSense code -->
    <div style="width: 100%; height: 90px; background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); display: flex; align-items: center; justify-content: center; color: white; font-family: Arial, sans-serif; border-radius: 8px;">
      <div style="text-align: center;">
        <div style="font-size: 18px; font-weight: bold;">Advertisement</div>
        <div style="font-size: 12px; opacity: 0.8;">Footer Banner - Replace with AdSense</div>
      </div>
    </div>`,
    image_url: "",
    link_url: "",
    active: true,
    start_date: null,
    end_date: null,
  },
  {
    name: "Between Games Ad - Game Card Style",
    type: "inline",
    position: "between-games",
    content: `<!-- Replace with your AdSense code -->
    <div style="height: 100%; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); display: flex; align-items: center; justify-content: center; position: relative; border-radius: 8px;">
      <div style="text-align: center; color: white;">
        <div style="font-size: 24px; margin-bottom: 8px;">🎮</div>
        <div style="font-size: 16px; font-weight: bold;">Play Now!</div>
        <div style="font-size: 12px; opacity: 0.8;">Sponsored Game</div>
      </div>
    </div>`,
    image_url: "",
    link_url: "",
    active: true,
    start_date: null,
    end_date: null,
  },
  {
    name: "After Game Ad - Square",
    type: "banner",
    position: "after-game",
    content: `<!-- Replace with your AdSense code -->
    <div style="width: 100%; height: 280px; background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%); display: flex; align-items: center; justify-content: center; color: #333; font-family: Arial, sans-serif; border-radius: 8px;">
      <div style="text-align: center;">
        <div style="font-size: 18px; font-weight: bold;">Advertisement</div>
        <div style="font-size: 12px; opacity: 0.8;">After Game Ad - Replace with AdSense</div>
      </div>
    </div>`,
    image_url: "",
    link_url: "",
    active: true,
    start_date: null,
    end_date: null,
  },
  {
    name: "Blog Above Post Ad - Premium Placement",
    type: "banner",
    position: "blog-above-post",
    content: `<!-- Replace with your AdSense code -->
    <div style="width: 100%; height: 200px; background: linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%); display: flex; align-items: center; justify-content: center; color: #333; font-family: Arial, sans-serif; border-radius: 12px; box-shadow: 0 4px 15px rgba(0,0,0,0.1);">
      <div style="text-align: center;">
        <div style="font-size: 20px; font-weight: bold; margin-bottom: 8px;">Premium Advertisement</div>
        <div style="font-size: 14px; opacity: 0.8;">Blog Above Post - Replace with AdSense</div>
        <div style="font-size: 12px; opacity: 0.6; margin-top: 4px;">High visibility placement</div>
      </div>
    </div>`,
    image_url: "",
    link_url: "",
    active: true,
    start_date: null,
    end_date: null,
  },
  {
    name: "Blog Related Games Native Ad",
    type: "inline",
    position: "blog-related-games",
    content: `<!-- Replace with your AdSense code -->
    <div style="height: 100%; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); display: flex; align-items: center; justify-content: center; border-radius: 8px; position: relative; overflow: hidden;">
      <div style="position: absolute; top: 8px; right: 8px; background: rgba(255,255,255,0.2); padding: 2px 6px; border-radius: 4px; font-size: 10px; color: white; opacity: 0.8;">Ad</div>
      <div style="text-align: center; color: white; padding: 16px;">
        <div style="font-size: 32px; margin-bottom: 8px;">🎯</div>
        <div style="font-size: 16px; font-weight: bold; margin-bottom: 4px;">Try This Game!</div>
        <div style="font-size: 12px; opacity: 0.8;">Sponsored Content</div>
      </div>
    </div>`,
    image_url: "",
    link_url: "",
    active: true,
    start_date: null,
    end_date: null,
  }
];
